import request from '@utils/request';

export async function getJobDetail(params) {
  try {
    const res = await request.post(`/api/official/mobile/job/getJobDetail`, params);
    return res;
  } catch (e) {
    return {};
  }
}

export async function getDeliveryStatus(params) {
  try {
    const res = await request.post(`/api/official/mobile/apply/job/deliveryStatus`, params);
    return res;
  } catch (e) {
    return {};
  }
}

// 校招项目互斥校验：查询立即申请按钮是否可用
export interface ICheckCanApply {
  canApply: boolean; // 是否可投递；false 时前端禁用按钮并展示 reason
  errorCode: string; // 错误码，如 PROJECT_EXCLUSIVE_BLOCK
  reason: string; // 提示文案，如"已投递xx，不可并行投递xx"
}
export async function checkCanApply(params: { jobId: string; source: string }): Promise<ICheckCanApply> {
  try {
    const res = await request.post(`/api/official/mobile/apply/job/checkCanApply`, params, {
      showErrorToast: false,
    } as any);
    return res;
  } catch (e) {
    return { canApply: true, errorCode: '', reason: '' };
  }
}
